var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"column"},_vm._l((_vm.list),function(item,idx){return _c('li',{key:idx},[_vm._v(" "+_vm._s(_vm.mapFn(item))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }